import React from 'react';
import { Tooltip, Typography } from 'antd';
import type { CompactStopDatesSummary } from './workspaceRouteRegistryProjection';

const { Text } = Typography;

function tooltipTitle(lines: string[]): React.ReactNode {
  if (lines.length <= 1) return null;
  return (
    <div>
      {lines.map((line) => (
        <div key={line}>{line}</div>
      ))}
    </div>
  );
}

export function WorkspaceRouteStopDatesCell({ summary }: { summary: CompactStopDatesSummary }) {
  const planTitle = tooltipTitle(summary.planTooltipLines);
  const factTitle = tooltipTitle(summary.factTooltipLines);

  const planNode = (
    <Text style={{ display: 'block', fontSize: 12, lineHeight: 1.35 }}>{summary.planLine}</Text>
  );
  const factNode = (
    <Text type="secondary" style={{ display: 'block', fontSize: 12, lineHeight: 1.35 }}>
      {summary.factLine}
    </Text>
  );

  return (
    <div style={{ minWidth: 0, lineHeight: 1.35 }}>
      {planTitle ? <Tooltip title={planTitle}>{planNode}</Tooltip> : planNode}
      {factTitle ? <Tooltip title={factTitle}>{factNode}</Tooltip> : factNode}
    </div>
  );
}
